import { getRoute } from '@/app/core/api/routes';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ResponseInterface } from '@/app/shared/interfaces/response.interface';

@Injectable({
  providedIn: 'root',
})
export class ResellerApiService {
  constructor(private http: HttpClient) {}

  sendBecomeResellerRequest(message: string = '') {
    const action = getRoute('reseller.request');

    return this.http.post<ResponseInterface<any>>(action, {
      message,
    });
  }
}
